import React from "react";
import { Route, Switch } from "react-router-dom";
import { injectIntl } from "react-intl";
import rtlDetect from "rtl-detect";
import { ToastContainer } from "@ebsco-ui/ebsco-ui";
import { ROUTES } from "../../../constants";
import Page from "../../containers/page";
import Update from "../../components/update";
import GenericError from "../../components/generic-error";
import PasswordUpdate from "../password-update";
import Create from "../create";
import PasswordReset from "../password-reset";
import DataRetentionPage from "../data-retention/data-retention-page";
import MergeAccounts from "../merge-accounts";
import SecretQuestionUpdate from "../secret-question-update";
import AppHeader from "./app-header";
import getIsCoppa from "../../store/coppa";
import { compose } from "redux";
import { connect } from "react-redux";
import sharedMessages from "../../../shared-messages";
export class App extends React.Component {
  componentDidMount() {
    const {
      intl: { locale },
      currentPage
    } = this.props;
    document.body.dir = rtlDetect.getLangDir(locale);
    // Remove display none style from body which was set to prevent
    // flash-of-unstyled-content
    window.document.body.removeAttribute("style");
    this.updateTitle(currentPage);
  }

  componentDidUpdate(prevProps) {
    const {
      intl: { locale },
      currentPage
    } = this.props;

    if (prevProps.intl.locale !== locale)
      document.body.dir = rtlDetect.getLangDir(locale);

    if (prevProps.currentPage !== currentPage) {
      this.updateTitle(currentPage);
      const announcer = document.getElementById("screen-reader-announcer");
      if (announcer) announcer.textContent = document.title;
    }
  }

  updateTitle = path => {
    const { DATA_RETENTION } = ROUTES;
    const {
      intl: { formatMessage }
    } = this.props;
    if (path === DATA_RETENTION) {
      document.title = formatMessage(sharedMessages.productsAndServices);
    } else {
      document.title = formatMessage(sharedMessages.myAccountEbsco);
    }
  };

  render() {
    const { locale } = this.props.intl;
    const {
      PASSWORD_UPDATE,
      DATA_RETENTION,
      ACCOUNT_UPDATE,
      ACCOUNT_CREATE,
      PASSWORD_RESET,
      MERGE_ACCOUNTS,
      SECRET_QUESTION
    } = ROUTES;
    return (
      <>
        <AppHeader />
        <div
          id="screen-reader-announcer"
          data-testid="screen-reader-announcer"
          aria-live="polite"
          style={{ position: "absolute", left: -9999 }}
        ></div>
        <ToastContainer rtl={rtlDetect.isRtlLang(locale)} />
        <Page>
          <Switch>
            <Route
              exact={true}
              path={PASSWORD_UPDATE}
              component={PasswordUpdate}
            />
            <Route
              exact={true}
              path={DATA_RETENTION}
              component={DataRetentionPage}
            />
            <Route exact={true} path={ACCOUNT_UPDATE} component={Update} />
            <Route exact={true} path={ACCOUNT_CREATE} component={Create} />
            <Route
              exact={true}
              path={PASSWORD_RESET}
              component={PasswordReset}
            />
            <Route
              exact={true}
              path={MERGE_ACCOUNTS}
              component={MergeAccounts}
            />
            <Route
              exact={true}
              path={SECRET_QUESTION}
              component={SecretQuestionUpdate}
            />
            <Route path="/*" component={GenericError} />
          </Switch>
        </Page>
      </>
    );
  }
}

const mapStateToProps = state => ({
  isCoppa: getIsCoppa(state),
  currentPage: state.router.location.pathname
});

export default compose(injectIntl, connect(mapStateToProps))(App);
